import React from 'react'
import { MakingMindsLearningFooter, MakingMindsNav } from '../route'

const Events = () => {
    return (
        <div>
            <MakingMindsNav />

            <div className="flex  w-full gap-8 justify-center  py-10 lg:py-10 px-4 bg-mcolor  sm:items-center  dark:bg-gray-800">
                <p className="text-3xl lg:text-5xl text-center justify-center font-semibold font-mfont text-mwhite
                 dark:text-gray-400">Making Minds Technologies Events.</p>
            </div>
            <div className='text-center justify-center mt-10'>
                <h2 className="text-3xl mb-10 font-semibold font-mfont text-mcolor sm:text-4xl">
                    Upcoming Trainings and Webinars.
                </h2>
            </div>

            <h4 className='text-center text-3xl mb-20 font-semibold font-mfont'>No Events found.</h4>
            {/* <div className="lg:flex shadow rounded-lg border m-8 mb-10 border-gray-400">
                <div className="bg-mcolor rounded-lg lg:w-2/12 lg:py-[68px] py-10 block h-full shadow-inner">
                    <div className="text-center tracking-wide">
                        <div className="text-mwhite font-mfont font-bold text-4xl ">14</div>
                        <div className="text-mwhite font-mfont font-bold text-2xl">April 2024</div>
                    </div>
                </div>
                <div className="w-full  lg:w-11/12 xl:w-full px-1 bg-white py-5 lg:px-2 lg:py-10 tracking-wide">
                    <div className="flex flex-row lg:justify-start justify-center">
                        <div className="text-mcolor font-medium text-md text-center lg:text-left px-2">
                            <i className="far fa-clock"></i> 6:30 PM
                        </div>

                    </div>
                    <div className="font-semibold text-mcolor mb-3 text-2xl font-mfont text-center lg:text-left px-2">
                        From Startup to Success: Unveiling the Entrepreneurial Journey.
                    </div>
                    <div className="text-mcolor font-semibold text-xl font-mfont text-center lg:text-left px-2">
                        Organiser : <span className='font-mfont font-bold text-xl '>Making Minds Technologies Private Limited.</span>
                    </div>
                    <div className="text-mcolor font-medium text-xl pt-1 font-mfont text-center lg:text-left px-2">
                        Guest : <span className='font-mfont font-bold text-xl '>Arun sankar Rajendran ,CEO at Mophra development Inc.</span>
                    </div>
                </div>
                <div className="flex flex-row items-center w-full lg:w-1/3 bg-mwhite lg:justify-end justify-center px-2 py-4 lg:px-0">
                    <span className="tracking-wider py-1 text-mwhite font-mfont bg-mcolor px-2 text-lg rounded leading-loose mx-2 font-semibold">
                        Up Coming
                    </span>
                    <a href='https://forms.gle/7CJmaGRRfum5kA3aA'
                        target='_blank' rel="noreferrer"
                        className="tracking-wider py-1 cursor-pointer text-mwhite bg-mgreen  font-mfont px-2 text-lg rounded leading-loose mx-2 font-semibold">
                        Register
                    </a>
                </div>
            </div> */}

            <MakingMindsLearningFooter />
        </div>
    )
}

export default Events